/*
 * The texts of the teams extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		team: {
			create: 'Team anlegen',
			edit: 'Team bearbeiten',
			settings: 'Team-Einstellungen',
		},
	},
	pages: {
		admin: {
			teams: {
				title: 'Teams',
				create: 'Team erstellen',
				edit: 'Team bearbeiten',
				users: 'Personen',
				events: 'Events',
			},
		},
		settings: {
			teams: {
				title: 'Teams',
			},
		},
	},
	sidebar: {
		teams: 'Teams',
	},
	modals: {
		admin: {
			edit_team: {
				create: 'Neues Team erstellen',
				edit: 'Team bearbeiten',
				users: 'Personen',
			},
		},
	},
	data: {
		team: {
			id: 'Id',
			name: 'Name',
			users_count: '# Personen',
			events_count: '# Events',
		},
	},
	notifications: {
		assigned_to_team: {
			icon: 'fa-building',
			title: 'Zu Team hinzugefügt',
			text: "Du wurdest zum Team '{team_name}' hinzugefügt.",
		},
	},
	contexts: {
		team: 'Team',
	},
};
